var map = {
	"./icon-stats-certificates.svg": 1408,
	"./icon-stats-courses.svg": 1409,
	"./icon-stats-exercises.svg": 1410,
	"./icon-stats-instructors.svg": 1411,
	"./icon-stats-projects.svg": 1412,
	"./icon-stats-rating.svg": 1413,
	"./icon-stats-reviews.svg": 1414,
	"./icon-stats-students.svg": 1415,
	"./icon-stats-video.svg": 1416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1614;